import {UserRightsVO} from '../api';
import {OVERLAY_LAYER_ID} from '../const';
import {EditorLayersMode, LayerId} from '@mc/react-mapio';

export function getUserLayerActions({
    opravneniData,
    writableLayers,
    serverPublic,
    isIframe,
    layersMode,
}: {
    opravneniData: UserRightsVO[];
    writableLayers: LayerId[];
    serverPublic: boolean;
    isIframe: boolean;
    layersMode: EditorLayersMode;
}) {
    let allowedInsertionLayers: LayerId[] = [];
    let allowedUpdateLayers: LayerId[] = [];
    let userActionTypes: {id: LayerId; actionType: string[]}[] = [];

    if (!serverPublic && !isIframe) {
        if (opravneniData) {
            opravneniData[0]?.layers
                .map(item => {
                    const actionTypes = [];
                    if (item.vlastnikVrstvy || item.actionRights.allActions) {
                        if (!actionTypes.includes('INSERT')) {
                            actionTypes.push('INSERT');
                        }
                        if (!actionTypes.includes('UPDATE')) {
                            actionTypes.push('UPDATE');
                        }
                        if (!actionTypes.includes('DELETE')) {
                            actionTypes.push('DELETE');
                        }
                    }
                    if (item.actionRights.actionList.some(i => i.typ === 'INSERT') && !actionTypes.includes('INSERT')) {
                        actionTypes.push('INSERT');
                    }
                    if (item.actionRights.actionList.some(i => i.typ === 'UPDATE') && !actionTypes.includes('UPDATE')) {
                        actionTypes.push('UPDATE');
                    }
                    if (item.actionRights.actionList.some(i => i.typ === 'DELETE') && !actionTypes.includes('DELETE')) {
                        actionTypes.push('DELETE');
                    }
                    if (actionTypes.length > 0) {
                        userActionTypes.push({
                            id: item.layer.id,
                            actionType: actionTypes,
                        });
                    }
                })
                .filter(Boolean);

            userActionTypes.forEach(({id, actionType}) => {
                if (actionType.includes('UPDATE')) {
                    if (writableLayers?.some(item => item === id)) {
                        allowedUpdateLayers.push(id);
                    }
                }
                if (actionType.includes('INSERT')) {
                    if (writableLayers?.some(item => item === id)) {
                        allowedInsertionLayers.push(id);
                    }
                }
            });
        }
    }
    if (serverPublic || isIframe || layersMode === EditorLayersMode.OVERLAY) {
        userActionTypes.push({
            id: OVERLAY_LAYER_ID,
            actionType: ['INSERT', 'UPDATE', 'DELETE'],
        });
        allowedInsertionLayers.push(OVERLAY_LAYER_ID);
        allowedUpdateLayers.push(OVERLAY_LAYER_ID);
    }
    return {allowedInsertionLayers, allowedUpdateLayers, userActionTypes};
}
